import css from "styled-jsx/css";
import { TABLET_QUERY_MAX_WIDTH, SMALL_MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css.global`
  .cluster-solutions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .signup-button-wrapper {
      max-width: 600px;
    }

    .solutions-image-wrapper {
      width: 80vw;

      .solutions-image {
        width: 100%;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .cluster-solutions {
      .solutions-image-wrapper {
        padding-top: 32px;
        width: 95vw;
      }
    }
  }

  @media (max-width: ${SMALL_MOBILE_QUERY_MAX_WIDTH}) {
    .cluster-solutions {
      .solutions-image-wrapper {
        padding-top: 48px;
      }
    }
  }
`;
